/**
 * Convert (if number) to css px value
 * Return as is if not
 */
export function toUnit(value: number | string): string {
  if (typeof value === 'number') {
    return `${value}px`;
  }

  return value;
}
